{
  "name": "planner-view",
  "version": "0.2.21",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build_prod": "node increment-version.js && ng build --configuration production",
    "githubpage": "ng build --configuration preprod && gh-pages -d ./dist/PlannerView/browser --repo https://github.com/f80dev/pl_webapp.git -f -t true -b main -m \"update from devnet\"",
    "deploy_preprod": "ng build --configuration preprod && npx wrangler pages deploy dist/PlannerView/browser --project-name=pl-webapp",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "~21.2.3",
    "@angular/common": "^21.2.3",
    "@angular/compiler": "^21.2.3",
    "@angular/core": "^21.2.3",
    "@angular/forms": "^21.2.3",
    "@angular/material": "~21.2.3",
    "@angular/platform-browser": "^21.2.3",
    "@angular/router": "^21.2.3",
    "@types/gapi": "^0.0.47",
    "@types/gapi.calendar": "^3.0.11",
    "html2canvas": "^1.4.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "wrangler": "^4.129.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.14.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.3",
    "@angular/cli": "^21.2.3",
    "@angular/compiler-cli": "^21.2.3",
    "@angular/material": "^21.2.3",
    "jsdom": "^27.1.0",
    "typescript": "^5.9.3",
    "vitest": "^4.0.8"
  }
}
